import { useState, useEffect, useCallback } from "react";
import { FaComments } from "react-icons/fa";
import { tableConstants } from "./StakeHolderQueryTableConst";
import Loader from "../../components/Loader/Loader";
import Pagination from "../../components/Pagination/Pagination";
import Table from "../../components/Table/Table";
import { enqueueSnackbar } from "notistack";
import QueryFilter from "./StakeHolderQueryFilter";
import Modal from "../../components/Modal/Modal";
import StackHolderQueryForm from "./StakeHolderQueryForm";
import {
  getStackHolderQueries,
  replyStackHolderQuery,
  stackHolderQueryStatus,
  getStackHolderDashboardData,
  getReguestTypeList,
  // getFlagList,
  updateStackHolderQueryStatus,
  updateStackHolderQuerySubType,
  removeReplyAttachment,
} from "../../services/StackHolderQueryService";
import { getStakeholderRequestTypes } from "../../services/StakeholderRequestTypeService";
import StackHolderQueryView from "./StakeHolderQueryView";
import StackHolderDashboard from "./StakeHolderDashboard";
import * as XLSX from "xlsx";
import { getOrganizationList } from "../../services/OrganizationService";
import headerArray from "./Header.json";

const StakeHolderQueryList = () => {
  const [permissions] = useState(
    JSON.parse(localStorage.getItem("permissions"))
  );
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const [totalPage, setTotalPage] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [dashboardData, setDashboardData] = useState([]);

  const [id_number, setIdNumber] = useState("");
  const [stakeholder_email, setStakeholderEmail] = useState("");
  const [ticket_no, setTicketNo] = useState("");
  const [stakeholder_mob, setStakeholderMob] = useState("");
  const [requestTypeList, setRequestTypeList] = useState([]);
  const [request_type, setRequestType] = useState("");
  const [reply_status, setReplyStatus] = useState("");
  const [query_details, setQueryDetails] = useState("");
  const [reply_attachment, setReplyAttachment] = useState("");
  const [organization_id, setOrganizationId] = useState("");
  const [attachment, setAttachment] = useState("");
  const [attachmentLoader, setAttachmentLoader] = useState(false);
  const [is_read, setIsRead] = useState("");
  // const [flagList, setFlagList] = useState([]);
  const [flag_id, setFlagId] = useState("");
  const [activeMenuRow, setActiveMenuRow] = useState(null);
  const [start_date, setStartDate] = useState("");
  const [end_date, setEndDate] = useState("");
  const [organizationList, setOrganizationList] = useState([]);
  const [subTypeList, setSubTypeList] = useState([]);
  const [suggestions, setSuggestions] = useState([]);

  const [query_id, setQueryId] = useState("");
  const [query_reply, setQueryReply] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [headers, setHeaders] = useState([]);
  const [params, setParams] = useState({});
  const [isDownloadLoader, setIsDownloadLoader] = useState(false);
  const [isUpdateStatus, setIsUpdateStatus] = useState(false);

  const closeHandler = () => {
    setIsOpen(false);
    setQueryId("");
    setQueryReply("");
    setIsRead("");
  };

  const searchHandler = (e) => {
    e.preventDefault();
    fetchStackHolderQueryList(1);
  };

  const fetchStackHolderQueryList = useCallback(
    async (page) => {
      try {
        setData([]);
        setCurrentPage(page);
        const params = { page: page };

        if (id_number) params.id_number = id_number;
        if (organization_id) {
          params.organization_id = organization_id;
          fetchStackHolderDashboardData(organization_id);
        }
        if (stakeholder_email) params.stakeholder_email = stakeholder_email;
        if (ticket_no) params.id = ticket_no;
        if (stakeholder_mob) params.stakeholder_mob = stakeholder_mob;
        if (request_type) params.request_type = request_type;
        if (reply_status) params.reply_status = reply_status;
        if (flag_id) params.flag_id = flag_id;
        if (start_date) params.start_date = start_date;
        if (end_date) params.end_date = end_date;
        setParams(params);
        setLoader(true);
        const response = await getStackHolderQueries(params);

        if (response.success) {
          setData(response.data);
          setTotalPage(response.last_page);
        }
      } catch (error) {
        console.error(error);
        setData([]);
        setTotalPage(0);
      } finally {
        setLoader(false);
      }
    },
    [
      id_number,
      organization_id,
      stakeholder_email,
      ticket_no,
      stakeholder_mob,
      request_type,
      reply_status,
      flag_id,
      start_date,
      end_date,
    ]
  );

  const fetchStackHolderDashboardData = async (organization_id) => {
    try {
      const response = await getStackHolderDashboardData(organization_id);
      setDashboardData(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchRequestTypeList = async () => {
    try {
      const response = await getReguestTypeList();
      if (response.status === 200) {
        let data = response.data.data.map((item) => ({
          id: item.name,
          name: item.name,
        }));
        setRequestTypeList(data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchStakeholderRequestTypeAndSubTypes = async () => {
    try {
      const response = await getStakeholderRequestTypes();
      if (response.success) {
        let list = response.data.map((item) => ({
          id: item.id,
          name: item.name,
          sub_types: item.sub_types
            ? [{ id: "", name: "N/A" }, ...item.sub_types]
            : [{ id: "", name: "N/A" }],
        }));
        setSubTypeList(list);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchOrganizationList = async () => {
    try {
      const response = await getOrganizationList();
      if (response.status === 200) {
        setOrganizationList(response.data.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchStackHolderQueryList(1);
    fetchStackHolderDashboardData();
    fetchRequestTypeList();
    fetchOrganizationList();
    fetchStakeholderRequestTypeAndSubTypes();
  }, [fetchStackHolderQueryList]);

  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    if (name === "id_number") {
      setIdNumber(value);
    } else if (name === "organization_id") {
      setOrganizationId(value);
    } else if (name === "stakeholder_email") {
      setStakeholderEmail(value);
    } else if (name === "ticket_no") {
      setTicketNo(value);
    } else if (name === "stakeholder_mob") {
      setStakeholderMob(value);
    } else if (name === "request_type") {
      setRequestType(value);
    } else if (name === "reply_status") {
      setReplyStatus(value);
    } else if (name === "query_reply") {
      setQueryReply(value);
    } else if (name === "flag_id") {
      setFlagId(value);
    } else if (name === "start_date") {
      setStartDate(value);
    } else if (name === "end_date") {
      setEndDate(value);
    }
  };

  const resetHandler = () => {
    setIdNumber("");
    setOrganizationId("");
    setStakeholderEmail("");
    setTicketNo("");
    setStakeholderMob("");
    setRequestType("");
    setReplyStatus("");
    setQueryReply("");
    setFlagId("");
    setStartDate("");
    setEndDate("");
    setParams({});
    fetchStackHolderQueryList(1);
  };

  const handleChange = (event) => {
    const { value } = event.target;
    setQueryReply(value);
  };

  const handlePageChange = (i) => {
    const page = i.selected + 1;
    fetchStackHolderQueryList(page);
  };

  // const fetchFlagList = async () => {
  //   try {
  //     const response = await getFlagList();
  //     if (response.status === 200) {
  //       setFlagList(response.data.data.flag_details);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  const redirectQueryDetails = async (id, is_read) => {
    const queryDetails = data.find((item) => item.id === id);
    setQueryDetails(queryDetails);
    setOrganizationId(queryDetails.organization_id);
    setAttachment(queryDetails.attachment);
    if (queryDetails.replies && queryDetails.replies.length > 0) {
      setQueryReply(queryDetails.replies[0].reply_message);
    }
    setIsOpen(true);
    setQueryId(id);
    setIsRead(is_read);
    try {
      const response = await stackHolderQueryStatus(id);
      if (response.status === 200) {
        // fetchStackHolderQueryList(1);
        // fetchStackHolderDashboardData();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const viewHandler = async (details, is_read) => {
    setIsOpen(true);
    setIsRead(is_read);
    setQueryDetails(details);
    try {
      setLoader(true);
      const response = await stackHolderQueryStatus(details.id);
      if (response.status === 200) {
        setSuggestions(response.data.data.suggestions || []);
        fetchStackHolderQueryList(1);
        fetchStackHolderDashboardData();
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  const excelHeaderHandler = (e) => {
    setHeaders(e);
  };

  const excelDownloadHandler = async (e) => {
    e.preventDefault();
    try {
      enqueueSnackbar("Please wait data is downloading...", {
        variant: "info",
      });
      params.is_download = true;
      setIsDownloadLoader(true);
      const response = await getStackHolderQueries(params);
      if (response.success) {
        let data = response.data;
        let selectedHeaders = headerArray.map((header) => header.id);
        if (headers && headers.length > 0) {
          selectedHeaders = headers.map((header) => header.id);
        }

        const resolveRequestSubtype = (item) => {
          const pickSubtypeFromObject = (obj) => {
            if (!obj || typeof obj !== "object") {
              return "";
            }

            return (
              obj.name ||
              obj.label ||
              obj.title ||
              obj.sub_type ||
              obj.request_sub_type ||
              ""
            );
          };

          const directSubtype =
            pickSubtypeFromObject(item.request_sub_type) ||
            pickSubtypeFromObject(item.request_subtype) ||
            item.request_subtype_name ||
            item.request_sub_type_name ||
            (typeof item.request_sub_type === "string"
              ? item.request_sub_type
              : "") ||
            (typeof item.request_subtype === "string"
              ? item.request_subtype
              : "");

          if (directSubtype) {
            return directSubtype;
          }

          const subtypeId =
            item.request_subtype_id || item.request_sub_type_id || "";

          if (!subtypeId) {
            return "";
          }

          const matchedSubtype = subTypeList
            .flatMap((type) => type.sub_types || [])
            .find((subType) => `${subType.id}` === `${subtypeId}`);

          return matchedSubtype?.name || "";
        };

        const filteredData = data.map((item) => {
          const filteredItem = {};

          const headerValueMap = {
            // Normalize known header/API key mismatches for export.
            query_no: item.query_no || item.id || "",
            admission_no: item.admission_no || item.id_number || "",
            read_user: item.read_user?.name || item.read_user || "",
            replied_by:
              item.replied_by || item.replies?.[0]?.reply_user?.name || "",
            reply_message:
              item.reply_message || item.replies?.[0]?.reply_message || "",
            reply_date: item.reply_date || item.replies?.[0]?.created_at || "",

            // API may return subtype as nested object in list payload.
            request_sub_type: resolveRequestSubtype(item),
          };

          selectedHeaders.forEach((header) => {
            if (headerValueMap.hasOwnProperty(header)) {
              filteredItem[header] = headerValueMap[header];
            } else if (item.hasOwnProperty(header)) {
              filteredItem[header] = item[header];
            }
          });
          return filteredItem;
        });
        const ws = XLSX.utils.json_to_sheet(filteredData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
        XLSX.writeFile(wb, `querylist.xlsx`);
        enqueueSnackbar("Data downloaded successfully", { variant: "success" });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsDownloadLoader(false);
    }
  };

  const handleSubmit = async (e, is_draft) => {
    e.preventDefault();
    setLoader(true);
    const formData = new FormData();
    formData.append("reply_attachment", reply_attachment);
    formData.append("reply_message", query_reply);
    formData.append("stakeholder_experience_id", query_id);
    formData.append("organization_id", organization_id);
    formData.append("is_draft", is_draft);

    try {
      const response = await replyStackHolderQuery(formData);
      if (response.status === 200) {
        setQueryId("");
        setQueryReply("");
        setIsOpen(false);
        fetchStackHolderQueryList(1);
        if (is_draft === 0) {
          enqueueSnackbar(response.data.message.success, {
            variant: "success",
          });
        } else {
          enqueueSnackbar("Draft saved successfully", { variant: "success" });
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
      setIsRead("");
    }
  };

  const subTypeChangeHandler = async (
    sub_type_id,
    stakeholder_experience_id
  ) => {
    const data = {
      request_subtype_id: sub_type_id,
      stakeholder_experience_id: stakeholder_experience_id,
    };
    try {
      const response = await updateStackHolderQuerySubType(data);
      if (response.status === 200) {
        setQueryId("");
        setQueryReply("");
        setIsOpen(false);
        fetchStackHolderQueryList(1);
        setActiveMenuRow(null);
        enqueueSnackbar(response.data.message.success, { variant: "success" });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
      setIsRead("");
    }
  };

  const statusUpdateHandler = async (
    reply_status,
    stakeholder_experience_id
  ) => {
    const data = {
      reply_status: reply_status,
      stakeholder_experience_id: stakeholder_experience_id,
    };

    try {
      const response = await updateStackHolderQueryStatus(data);
      if (response.status === 200) {
        setQueryId("");
        setQueryReply("");
        setIsOpen(false);
        fetchStackHolderQueryList(1);
        enqueueSnackbar(response.data.message.success, { variant: "success" });
        setActiveMenuRow(null);
        setIsUpdateStatus(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
      setIsRead("");
    }
  };

  const removeReplyAttachmentHandler = async (query_id, reply_id) => {
    try {
      setAttachmentLoader(true);
      const response = await removeReplyAttachment({
        stakeholder_experience_id: query_id,
        reply_id: reply_id,
      });

      if (response.status === 200) {
        // Clear local state attachment
        setAttachment("");
        // Update query_details to remove reply_attachment
        setQueryDetails((prev) => {
          if (!prev) return prev;
          const updatedReplies = prev.replies.map((r) =>
            r.id === reply_id ? { ...r, reply_attachment: null } : r
          );
          return { ...prev, replies: updatedReplies };
        });
        enqueueSnackbar(response.data.message.success, { variant: "success" });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setAttachmentLoader(false);
      setIsRead("");
    }
  };

  return (
    <div className="card">
      {loader ? (
        <Loader />
      ) : (
        <div className="roleUser-list">
          <div className="card-header">
            <div className="row">
              <div className="col-md-3 main-title-page page-title">
                <FaComments /> Stakeholder Queries
              </div>
            </div>
          </div>
          <div className="card-body">
            <StackHolderDashboard dashboardData={dashboardData} />
            <Modal
              title={"Query Details"}
              show={query_id}
              isOpen={isOpen}
              onClose={closeHandler}
              onHide={() => setQueryId(null)}
              size="full"
            >
              {is_read === "view" ? (
                <StackHolderQueryView
                  query_details={query_details}
                  statusUpdateHandler={statusUpdateHandler}
                  isUpdateStatus={isUpdateStatus}
                  setIsUpdateStatus={setIsUpdateStatus}
                  activeMenuRow={activeMenuRow}
                  setActiveMenuRow={setActiveMenuRow}
                  suggestions={suggestions}
                  viewHandler={viewHandler}
                />
              ) : (
                <StackHolderQueryForm
                  attachment={attachment}
                  attachmentLoader={attachmentLoader}
                  query_details={query_details}
                  setReplyAttachment={setReplyAttachment}
                  reply_attachment={reply_attachment}
                  query_id={query_id}
                  query_reply={query_reply}
                  setQueryReply={setQueryReply}
                  closeHandler={closeHandler}
                  onChangeHandler={onChangeHandler}
                  handleSubmit={handleSubmit}
                  handleChange={handleChange}
                  removeReplyAttachmentHandler={removeReplyAttachmentHandler}
                />
              )}
            </Modal>
            <QueryFilter
              headerArray={headerArray}
              selectedHeaders={headers}
              id_number={id_number}
              organizationList={organizationList}
              organization_id={organization_id}
              stakeholder_email={stakeholder_email}
              ticket_no={ticket_no}
              stakeholder_mob={stakeholder_mob}
              request_type={request_type}
              reply_status={reply_status}
              requestTypeList={requestTypeList}
              searchHandler={searchHandler}
              onChangeHandler={onChangeHandler}
              resetHandler={resetHandler}
              excelDownloadHandler={excelDownloadHandler}
              excelHeaderHandler={excelHeaderHandler}
              start_date={start_date}
              end_date={end_date}
              isDownloadLoader={isDownloadLoader}
            />
            {data && data.length ? (
              <Table
                cols={tableConstants(
                  permissions,
                  redirectQueryDetails,
                  viewHandler,
                  currentPage,
                  activeMenuRow,
                  setActiveMenuRow,
                  subTypeList,
                  subTypeChangeHandler
                )}
                data={data}
                hoverable={true}
              />
            ) : (
              <div
                className="
               d-flex flex-column
               align-items-center
               justify-content-center vh-10"
              >
                <div>
                  <p className="mt-3">No data found.</p>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {data && data.length ? (
        <Pagination
          totalPage={totalPage}
          currentPage={currentPage - 1}
          handlePageChange={(i) => handlePageChange(i)}
        />
      ) : null}
    </div>
  );
};

export default StakeHolderQueryList;
